import React from 'react';
import { Policies } from '../components/Policies';

export default function PoliciesPage() {
  return (
    <div className="pt-24">
      <Policies />
    </div>
  );
}